import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { Card } from '../../../../../components/card/card';
import { Chip } from '../../../../../components/chip/chip';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Table } from '../../../../../features/table/table';
import { TableFilterInput } from '../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { TableFilterSingleSelect } from '../../../../../features/table/table-filter/table-filter-single-select/table-filter-single-select';
import { buildParams, concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import {
  ManagerPath,
  QrCodesPath,
  RootPath,
  TreesPath,
} from '../../../../../routes/manager/manager-enums';
import { useBranchesStore } from '../../../../../store/use-branch-store';
import { useTreeStore } from '../../../../../store/use-tree-store';
import s from './tree-table.module.css';

export const TreeTable = () => {
  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();
  const { list } = useTreeStore();
  const { place } = useBranchesStore();

  return (
    <Card>
      <Table
        id="tree-list"
        columnSettings
        frontPagination
        withArchive
        className={s.table}
        onEmpty={{
          title: t('Список деревьев пуст'),
          text: t('Создайте первое дерево услуг с помощью кнопки выше'),
        }}
        cols={{
          name: {
            label: t('Название'),
            filter: (
              <TableFilterInput
                name="name"
                suggestOptions={list?.map((item) => getLocale(item.name))}
              />
            ),
          },
          description: {
            label: t('Описание'),
            filter: (
              <TableFilterInput
                name="description"
                suggestOptions={list?.map((item) => getLocale(item.description))}
              />
            ),
            maxWidth: 300,
          },
          branch: {
            label: t('Филиал'),
            filter: (
              <TableFilterSingleSelect
                name="branch"
                options={place?.map((item) => ({
                  id: String(item.id),
                  value: getLocale(item.name),
                }))}
              />
            ),
          },
          qrInUse: {
            label: t('QR'),
            filter: <TableFilterInput name="qr" />,
          },
          actions: { label: t('Действия') },
        }}
        rows={list?.map((item) => ({
          name: getLocale(item.name),
          description: getLocale(item.description),
          branch: item.branches ? (
            <ul className={s.chips}>
              {item.branches.map((branch) => (
                <Chip variant="info" key={branch.id}>
                  {getLocale(branch.value)}{' '}
                </Chip>
              ))}
            </ul>
          ) : (
            t('Нет')
          ),
          qrInUse: item.qr ? (
            <ul className={s.chips}>
              {item.qr.map((qr) => (
                <Link
                  key={qr.id}
                  to={
                    concatPath([RootPath.Manager, ManagerPath.QrCodes, QrCodesPath.EditStatic]) +
                    buildParams({ id: qr.id })
                  }
                >
                  <Chip variant="info">{getLocale(qr.value)} </Chip>
                </Link>
              ))}
            </ul>
          ) : (
            t('Нет')
          ),
          actions: (
            <HasAccess service="tree" permissions={['write']}>
              {item.is_deleted ? (
                <IconButton
                  tooltip={t('Восстановить')}
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    addQueryParams({
                      restoreId: String(item.id),
                      restoreName: getLocale(item.name),
                    })
                  }
                >
                  <TbRestore />
                </IconButton>
              ) : (
                <div className={s.actions}>
                  <Link
                    to={
                      concatPath([RootPath.Manager, ManagerPath.Trees, TreesPath.EditTree]) +
                      buildParams({ id: item.id })
                    }
                  >
                    <IconButton tooltip={t('Редактировать')} size="sm" variant="secondary">
                      <AiOutlineEdit />
                    </IconButton>
                  </Link>

                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    onClick={() =>
                      addQueryParams({
                        deleteId: item.id.toString(),
                        deleteName: getLocale(item.name),
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                </div>
              )}
            </HasAccess>
          ),
        }))}
      />
    </Card>
  );
};
